import globalData from "./FEU_DATA";

/**
 * The combined result of the default data and global data objects.
 */
export default Object.assign( {
    allowVideoUploads: false,
    videoFeatureAvailable: false,
    i18n: {
        dialogTitle: "Upload Files",
        dialogCancel: "Cancel",
        dialogClose: "Close",
        dialogUpload: "Upload",
        fileAllTooLarge: "The file exceeds the maximum size of %s.",
        fileAllTooLargePlural: "The files exceed the maximum size of %s.",
        fileSomeTooLarge: "A file exceeded the maximum size of %s.",
        fileSomeTooLargePlural: "Some files exceeded the maximum size of %s.",
        fileTooMany: "You can only upload %d file at a time.",
        fileTooManyPlural: "You can only upload %d files at a time.",
        fileTypeNotAllowed: "File type %1$s is not allowed. Allowed types: %2$s",
        fileTypeNotAllowedPlural: "Some files have unsupported types. Allowed types: %s",
        fileRemove: "Remove",
        fileName: "File Name",
        fileType: "File Type",
        fileSize: "File Size",
        fileDimensions: "Dimensions",
        fileStatusVideo: "Video upload",
        fileStatusInvalid: "Needs attention",
        fieldName: "Name",
        fieldEmail: "Email",
        fieldCaption: "Caption",
        fieldDescription: "Description",
        fieldAlt: "Alt",
        fieldCustomUrl: "Custom Url",
        fieldCustomTarget: "Custom Target",
        fieldTags: "Tags",
        fieldAdditionalInfo: "Additional",
        fieldAdditionalLongInfo: "Additional",
        restUploading: "Uploading, please wait...",
        imageOptimizationPreparing: "Optimizing images… %1$d of %2$d",
        filePreparationPreparing: "Preparing files… %1$d of %2$d",
        filePreparationFailed: "The selected files could not be prepared. Cancel and choose the files again.",
        noFilesToPrepare: "No files could be prepared. Cancel and choose one or more supported files.",
        restBadResponse: "An unexpected response was received from the server.",
        restNetworkError: "An error occurred uploading the files.",
        videoUploadsUnavailable: "Video uploads are not currently available because FooGallery video support is not active on this site.",
        videoPosterFailed: "A preview image could not be generated for this video. Remove it or choose a different MP4 file.",
        videoPosterInvalid: "Video uploads require a generated poster image.",
        imageOptimizationDecodeFailed: "This image could not be decoded for browser optimization and will not be uploaded. Try a different image or browser.",
        imageOptimizationUnavailable: "Your browser could not optimize this image, so it will not be uploaded. Try a different browser or ask the site owner to disable image optimization.",
        imageOptimizationFormatUnsupported: "Your browser cannot export the requested image format, so this file will not be uploaded. Try a different browser or ask the site owner to select JPEG or PNG.",
        imageOptimizationTypeNotAllowed: "This gallery does not allow the optimized %s format, so this file will not be uploaded. Ask the site owner to update the optimization format or allowed file types.",
        resultSucceeded: "Uploaded",
        resultErrored: "Errored",
        resultSkipped: "Skipped",
        resultLocalSkippedSingle: " %d upload skipped.",
        resultLocalSkippedPlural: " %d uploads skipped.",
        requiredFieldsError: "Please fill in all required fields (marked with *).",
        noValidFiles: "No valid uploads are ready to submit."
    },
    rest: {
        endpoint: null,
        nonce: null
    },
    customTargets: [
        { value: "default", label: "Default" },
        { value: "_blank", label: "New Tab (_blank)" },
        { value: "_self", label: "Same Tab (_self)" }
    ]
}, globalData );
